module.exports = __webpack_public_path__ + "img/rightIcon.96e227a1.svg";